// extracted by mini-css-extract-plugin
export var card = "Lands-module--card--1e581";
export var cardImage = "Lands-module--cardImage--42dc7";
export var container = "Lands-module--container--a3136";